<template>
    <!-- 发布 -->
    <el-main
        style="
            width: 234px;
            height: 100vh;
            margin-top: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
        "
    >
        <div>
            <div style="text-align: center"><el-button type="primary" @click="publishwj()">{{$t('PublishProject.StartPublishing')}}</el-button></div>
            <div style="text-align: center; margin-top: 20px">{{$t('PublishProject.ShareableQuestionnaire')}}</div>
        </div>
    </el-main>
</template>

<script>
export default {
    name: 'PublishProject',
	data() {
		return {
			wid: sessionStorage.getItem('wid') || 0,
			curWjInfo: {}
		};
	},
	watch: {
		'$route': {
			immediate: true,
			handler(to, from) {
				console.log('to.name123123123', to.name,from)
			}
		}
	},
	mounted() {		
       let wstate =  sessionStorage.getItem('wstate');
       if (wstate == 2) {
            this.$router.push({ path: '/wjmanage/wjpub/shareLink'})
       } else {
			this.wjinfo();
	   }
	},
	methods: {
		wjinfo() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				url: `${this.$config.service.wjinfo}?id=${id}`,
				method: 'POST',
				cb(res) {
					if (res.code == 0) {
						that.curWjInfo = res.resultBody;
					}
				}
			};
			this.$util.request(params);
		},
		publishwj() {
			let that = this;
			let title = this.$functions.html2string(this.curWjInfo.wjTitle);
			if (title.length > 20) {
				title = title.slice(0, 20) + '...';
			}
			let id = this.curWjInfo.id;
			this.$confirm(`【${title}】${this.$t('PublishProject.AndaPastiInginMenerbitkan')}?`, this.$t('main.tip'), {
				confirmButtonText: this.$t('main.ok'),
				cancelButtonText: this.$t('main.cancel'),
				type: 'warning'
			})
				.then(() => {
					that.loading = that.$loading({
						lock: true,
						text: that.$t('PublishProject.Penerbitan'),
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					let params = {
						that: that,
						url: `${that.$config.service.publishwj}?id=${id}&state=2`,
						data: {},
						method: 'POST',
						cb(res) {
							that.loading.close();
							that.loading = null;
							// if (res.code == 0) {
							that.$message({
								type: 'success',
								duration: 800,
								message: that.$t('PublishProject.BerjayaDiterbitkan')
							});
							sessionStorage.setItem('wstate', 2);
                            that.$router.push({ path: '/wjmanage/wjpub/shareLink' })
						}
					};
					that.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('PublishProject.TidakDiterbitkan')
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped="scoped">

</style>
